import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useAuth } from "./AuthContext";

export default function PaymentCancelScreen() {
  const navigation = useNavigation();
  const { authToken, user } = useAuth();

  const handleBack = () => {
    if (authToken) {
      // WP7: a restricted user has no AITutor route - send them back to the plan page.
      navigation.navigate(user?.subscription_restricted ? "UpgradePlan" : "AITutor");
    } else {
      navigation.navigate("Login");
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Text style={styles.title}>Payment canceled</Text>
        <Text style={styles.subtitle}>
          No worries — your payment was not completed. You can try again anytime.
        </Text>
        <TouchableOpacity onPress={handleBack} style={styles.cta}>
          <Text style={styles.ctaText}>Back to App</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f3f6fb",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  card: {
    width: "90%",
    maxWidth: 520,
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 24,
    borderWidth: 1,
    borderColor: "#e2e8f0",
    alignItems: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "700",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 14,
    color: "#475569",
    textAlign: "center",
    marginTop: 8,
  },
  cta: {
    marginTop: 20,
    paddingVertical: 12,
    paddingHorizontal: 18,
    borderRadius: 10,
    backgroundColor: "#2563eb",
  },
  ctaText: {
    color: "#fff",
    fontWeight: "700",
  },
});
